import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {UserVerificationService} from "../../services/user-verification.service";
import {KeycloakService} from "../../services/keycloak.service";

import {PeerNetworkNodeModel} from "../../models/peer-network-node.model";
import {RoamingPolicyPairModel} from "../../models/roaming-policy-pair.model";
import {RoamingAgreementPeeringsModel} from "../../models/roaming-agreement-peerings.model";
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-roaming-agreement-peerings',
  templateUrl: `./roaming-agreement-peerings.component.html`,
})
export class RoamingAgreementPeeringsComponent implements OnInit, OnDestroy {

  private apiUrl = ApiEndpoints.GET_ROAMING_AGREEMENT_PEERINGS;
  private userUrl = ApiEndpoints.GET_USER;

  isAdmin: boolean = false;
  username: string = KeycloakService.username;

  roamingAgreementPeerings: RoamingAgreementPeeringsModel = new RoamingAgreementPeeringsModel();

  constructor(private route: ActivatedRoute,
                private http: HttpClient,
                private router: Router,
                private userVerificationService: UserVerificationService) {
    this.isAdmin = this.userVerificationService.isAdmin;
    this.getRoamingAgreementPeerings();
  }

  getData() {
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    var body: any = {"username": this.username};
    return this.http.post<any>(this.apiUrl, body, options)
  }

  getRoamingAgreementPeerings() {
    this.getData().subscribe(peerings => {
      this.roamingAgreementPeerings = new RoamingAgreementPeeringsModel(peerings.allNetworkServers, peerings.allRoamingAgreements);
    })
  }

  ngAfterViewInit() {
      $("#menu0").addClass("collapse");
      $("#menu0").prev().addClass("collapsed");
      $("#menu1").addClass("collapse");
      $("#menu1").prev().addClass("collapsed");
      $("#menu2").addClass("collapse");
      $("#menu2").prev().addClass("collapsed");
      $("#menu3").addClass("collapse");
      $("#menu3").prev().addClass("collapsed");
      $("#menu4").addClass("collapse");
      $("#menu4").prev().addClass("collapsed");
      $("#menu5").removeClass("collapse");
      $("#menu5").prev().removeClass("collapsed");
    }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  hasAgreementFromTo(nsA: PeerNetworkNodeModel, nsB: PeerNetworkNodeModel) {
    let agreement = this.roamingAgreementPeerings.getAgreementFromTo(nsA.virtualId, nsB.virtualId)
    if(agreement) return true;
    return false;
  }
}
